import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { CookieConsentService } from '../../core/services/cookie-consent.service';
import { CookieConsent } from '../../core/models/cookie-consent.model';

@Component({
  selector: 'app-cookie-settings',
  templateUrl: './cookie-settings.page.html',
  styleUrls: ['./cookie-settings.page.scss']
})
export class CookieSettingsPage implements OnInit, OnDestroy {
  consent$!: Observable<CookieConsent>;
  prefs: Pick<CookieConsent, 'ads' | 'analytics'> = { ads: false, analytics: false };

  private sub?: Subscription;

  constructor(private cookieConsentService: CookieConsentService) {
    this.consent$ = this.cookieConsentService.consent$;
  }

  ngOnInit(): void {
    this.sub = this.consent$.subscribe(consent => {
      this.prefs = {
        ads: consent.ads,
        analytics: consent.analytics
      };
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  save(): void {
    this.cookieConsentService.setPartialConsent({ ...this.prefs });
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
  }

  reject(): void {
    this.cookieConsentService.rejectNonEssential();
  }
}
